var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuyingAHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Real-Estate-Sign-For-Sale--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Real Estate Sign For Sale Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.5h3s0.5 0 0.5 0.5v3.5s0 0.5 -0.5 0.5h-3s-0.5 0 -0.5 -0.5V20s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.5h3s0.5 0 0.5 0.5v3.5s0 0.5 -0.5 0.5h-3s-0.5 0 -0.5 -0.5V20s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.38 3.75a0.64 0.64 0 0 0 -0.63 -0.63 0.13 0.13 0 0 0 -0.13 0.13v1a0.13 0.13 0 0 0 0.13 0.13 0.64 0.64 0 0 0 0.63 -0.63Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.12a0.38 0.38 0 0 0 -0.38 0.38v1.12a0.26 0.26 0 0 0 0.26 0.26h0.24a0.26 0.26 0 0 0 0.26 -0.26V11.5a0.38 0.38 0 0 0 -0.38 -0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0h-19A1.5 1.5 0 0 0 1 1.5v15A1.5 1.5 0 0 0 2.5 18h19a1.5 1.5 0 0 0 1.5 -1.5v-15A1.5 1.5 0 0 0 21.5 0ZM10.38 3.5a1.62 1.62 0 1 1 3.24 0v3a1.62 1.62 0 0 1 -3.24 0Zm-4.5 9a2.47 2.47 0 0 1 1.24 2 1.61 1.61 0 0 1 -1.62 1.62h-1a0.62 0.62 0 1 1 0 -1.24h1a0.38 0.38 0 0 0 0.38 -0.38c0 -0.42 -0.26 -0.63 -0.76 -1a2.47 2.47 0 0 1 -1.24 -2A1.61 1.61 0 0 1 5.5 9.88h1a0.62 0.62 0 1 1 0 1.24h-1a0.38 0.38 0 0 0 -0.38 0.38c0 0.42 0.26 0.63 0.76 1Zm1.74 -6.12V7.5a0.62 0.62 0 0 1 -1.24 0v-4A1.61 1.61 0 0 1 8 1.88h1a0.62 0.62 0 0 1 0 1.24H8a0.38 0.38 0 0 0 -0.38 0.38v1.12a0.26 0.26 0 0 0 0.26 0.26h0.62a0.62 0.62 0 0 1 0 1.24h-0.62a0.26 0.26 0 0 0 -0.26 0.26Zm3.5 9.12a0.62 0.62 0 1 1 -1.24 0v-1.12a0.26 0.26 0 0 0 -0.26 -0.26h-0.24a0.26 0.26 0 0 0 -0.26 0.26v1.12a0.62 0.62 0 0 1 -1.24 0v-4a1.62 1.62 0 0 1 3.24 0Zm3.38 0.62h-1a1.61 1.61 0 0 1 -1.62 -1.62v-4a0.62 0.62 0 0 1 1.24 0v4a0.38 0.38 0 0 0 0.38 0.38h1a0.62 0.62 0 0 1 0 1.24Zm1.12 -8.79v0.17a0.62 0.62 0 0 1 -1.24 0v-5a0.62 0.62 0 0 1 0.62 -0.62h0.75a1.87 1.87 0 0 1 1 3.47 0.25 0.25 0 0 0 -0.09 0.34l0.9 1.49a0.63 0.63 0 1 1 -1.08 0.64l-0.37 -0.62a0.25 0.25 0 0 0 -0.28 -0.12 0.26 0.26 0 0 0 -0.21 0.25Zm1.76 5.55h1.12a0.62 0.62 0 0 1 0 1.24h-1.12a0.26 0.26 0 0 0 -0.26 0.26v0.12a0.38 0.38 0 0 0 0.38 0.38h1a0.62 0.62 0 1 1 0 1.24h-1a1.61 1.61 0 0 1 -1.62 -1.62v-3a1.61 1.61 0 0 1 1.62 -1.62h1a0.62 0.62 0 0 1 0 1.24h-1a0.38 0.38 0 0 0 -0.38 0.38v1.12a0.26 0.26 0 0 0 0.26 0.26Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.88a0.38 0.38 0 0 0 0.38 -0.38v-3a0.38 0.38 0 0 0 -0.76 0v3a0.38 0.38 0 0 0 0.38 0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuyingAHome);
export default ForwardRef;